export default function (img, preference) {
  const allFormats = ['large', 'medium', 'small', 'thumbnail'];
  const preferenceIndex = allFormats.indexOf(preference);
  const searchFormats = allFormats.splice(preferenceIndex);
  const bestFormatAvailable = searchFormats.find((f) => img.formats[f]);
  return img.formats[bestFormatAvailable]?.url;
}
